import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dupont-analysis-calculator',
  component: () => import('../../routes/DuPontAnalysisCalculator.svelte'),
  card: {
    id: 'dupont-analysis-calculator',
    title: 'DuPont Analysis Calculator',
    description:
      'Break down Return on Equity (ROE) into Profit Margin, Asset Turnover, and Financial Leverage components.',
    icon: 'analytics',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/dupont-analysis-calculator',
    category: 'Business',
  },
  seo: {
    title: 'DuPont Analysis Calculator — Decompose ROE into Drivers',
    description:
      'Calculate Return on Equity using the DuPont method — break down ROE into profit margin, asset turnover, and financial leverage to understand what drives your company\'s returns.',
  },
};

export default meta;
